import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from '../app.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-user-inactivity-review',
  templateUrl: './user-inactivity-review.component.html',
  styleUrl: './user-inactivity-review.component.css'
})
export class UserInactivityReviewComponent {

  spinner: boolean = false;
  currentUser: any;
  users: any;
  usersList: any;
  radioValue = 'active';
  updateModal: boolean = false;
  updateForm: FormGroup;
  selectedRep: any;

  constructor(
    private dataService: DataserviceService,
    private modal: NzModalService,
    private app: AppComponent,
    private nzNotify: NzNotificationService,
    private router: Router
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.updateForm = new FormGroup({
      status: new FormControl(null),
      note: new FormControl('')
    })
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.getUsers();
  }

  getUsers() {
    let params = this.setParams();

    this.dataService.getData(`user-inactivity-review`, { params }).subscribe((r: any) => {
      this.users = r;
      this.usersList = r;
    })
  }

  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission);
  }

  setParams() {
    let params = new HttpParams()

    if (this.hasPermission('view_all_users')) {
      params = params.set('all', true);
    }
    else if (this.hasPermission('view_distributor_users')) {
      params = params.set('distributor_id', this.currentUser.distributor_id);
    }
    else if (this.hasPermission('view_company_users')) {
      params = params.set('company_id', this.currentUser.company_id);
    }
    else if (this.currentUser?.viewable_groups?.length > 0) {
      params = params.set('viewable_groups', this.currentUser.viewable_groups);
    }
    else {
      params = params.set('my_id', this.currentUser.id);
    }

    return params;
  }

  search(event: any) {
    const keyword = event?.target?.value || '';

    if (!this.users || !Array.isArray(this.users)) {
      return;
    }

    if (!keyword.trim()) {
      this.usersList = this.users;
      return;
    }

    const lowerValue = keyword.toLowerCase();

    this.usersList = this.users.filter((item: any) => {
      let name = (item.first_name + ' ' + item.last_name).toLowerCase();
      let email = (item.email || '').toLowerCase();
      let phoneNumber = (item.phone || '').toString();
      let id = String(item.user_id || '');
      let status = (item.uir_status || '').toLowerCase();

      return (
        name.includes(lowerValue) ||
        email.includes(lowerValue) ||
        phoneNumber.includes(lowerValue) ||
        id.includes(keyword) ||
        status.includes(lowerValue)
      );
    });
  }

  phoneNumberDisplay(phone: string) {
    if (!phone) {
      return ''
    }
    const digits = phone.toString().replace(/\D/g, '');
    const cleanNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    return cleanNumber.length == 10 ? cleanNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3') : phone.toString();
  }

  showModal(rep: any){
    this.updateModal = true;
    this.selectedRep = rep;
    console.log(this.selectedRep)
    this.updateForm.patchValue({
      status: rep?.uir_status || null,
      note: rep?.note || ''
    });
  }

  cancelModal(){
    this.updateModal = false;
    this.selectedRep = null;
    this.updateForm.reset({
      status: null,
      note: ''
    });
  }

  confirmModal(){
    this.updateModal = false;
    const statusValue = this.updateForm.get('status')?.value || null;
    let noteValue = this.updateForm.get('note')?.value || '';

    const statusAtValue = new Date().toISOString();
    let delayedValue: string | null = null;

    if (statusValue === 'snoozed') {
      const later = new Date();
      later.setDate(later.getDate() + 30);
      delayedValue = later.toISOString();
    }

    let obj = {
      status: statusValue,
      statusAt: statusAtValue,
      delayedTo: delayedValue,
      currentUser: this.currentUser.id,
      note: noteValue,
      uirId: this.selectedRep.id
    }

    this.dataService.post('user-inactivity-review/update-status', obj).subscribe((r: any)=>{
      console.log(r)
      if (r && r.result === 'success') {
        this.nzNotify.success('User updated', 'The user inactivity review was updated.', { nzPlacement: 'top' });
        this.getUsers();
      } else {
        this.nzNotify.error('Update failed', 'Something went wrong trying to update the user.', { nzPlacement: 'top' });
      }
    }, (err: any) => {
      console.error(err);
      this.nzNotify.error('Update failed', 'Something went wrong trying to update the user.', { nzPlacement: 'top' });
    })

    console.log(obj);
  }

}
